import React from 'react';
import { useTask } from '../contexts/TaskContext';

export default function AchievementPopup() {
  const { achievement } = useTask();
  if (!achievement) return null;

  return (
    <div className="achievement-popup" role="status" aria-live="polite">
      <div className="achievement-card">
        <img
          src="/lion-end-of-day.png"
          alt=""
          className="achievement-lion"
          aria-hidden="true"
        />
        <div className="achievement-text">達成おめでとう！</div>
        {achievement.name && (
          <div className="achievement-name">{achievement.name}</div>
        )}
      </div>
    </div>
  );
}
